<template>
    <div>
            <div class="flex bottom8">
                <!--<el-radio-group v-model="c_type" @input="typeChange">
                    <el-radio :label='1'>收款</el-radio>
                    &lt;!&ndash;<el-radio :label='0'>付款</el-radio>&ndash;&gt;
                </el-radio-group>-->
                <el-date-picker style="width: 200px" class="marr4" clearable size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  v-model="searchTime" @change="dateChange"  type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
                <el-select style="width: 145px" @change="changegs"  class="marr4" v-model="i_gsid" size="mini" placeholder="请选择购买方" >
                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" @change="changekh" class="marr4" v-model="i_khid" size="mini" clearable remote :remote-method="remoteMethodkh" filterable placeholder="请选择开票方">
                    <el-option v-for="item in khList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 90px" class="marr4" v-model="invoiceStatus" size="mini" >
                    <el-option v-for="item in invoiceStatusList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 90px" class="marr4" v-model="invoiceType" size="mini" >
                    <el-option v-for="item in invoiceTypeList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 120px" class="marr4" v-model="fetachStatus" size="mini" >
                    <el-option v-for="item in fetachStatusList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="搜索发票代码"  v-model="invoiceCode"> </el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="搜索发票号码"  v-model="invoiceNum"> </el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="搜索全电号码"  v-model="electronicNumber"> </el-input>
                <el-button class="mrl20" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
                <el-button class="mrl20" icon="el-icon-refresh" circle  @click="clearSearchData" size="mini"></el-button>
            </div>
            <div class="flex bottom8">
                <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="addnew">获取发票</el-button>
            </div>
        <el-table class="mrt10" ref="table"  size="mini"  :height="tableHeight" border :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}":highlight-current-row="true"style="width: 100%;margin-right: 9px;margin-left: 9px">
            <el-table-column  label="序号" align="center" type="index" width="45px"></el-table-column>
            <el-table-column align="center" label="开票时间" prop="invoiceDate"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div :class="[scope.row.invoiceType==2?'red':'']">{{scope.row.invoiceDate}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="开票方" prop="sellerName"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div :class="[scope.row.invoiceType==2?'red':'']">{{scope.row.sellerName}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="发票号码" prop="invoiceNum"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div :class="[scope.row.invoiceType==2?'red':'']">{{scope.row.invoiceNum}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="全电发票号码" prop="electronicNumber"    show-overflow-tooltip>
                <template slot-scope="scope">
                        <div :class="[scope.row.invoiceType==2?'red':'']">{{scope.row.electronicNumber}}</div>
                    </template>
            </el-table-column>

            <el-table-column align="center" label="发票状态" width="70px" prop="invoiceStatus"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <div :class="[scope.row.invoiceType==2?'red':'']">{{scope.row.invoiceStatus}}</div>
                </template>
            </el-table-column>
<!--            <el-table-column align="center" label="品种" prop="vc_khname"    show-overflow-tooltip>-->
<!--                <template slot-scope="scope">-->
<!--                    <div :class="[scope.row.invoiceType==2?'red':'']">{{scope.row.red}}</div>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="center" label="开票金额" prop="invoiceAmount"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div :class="[scope.row.invoiceType==2?'red':'']">{{scope.row.invoiceAmount}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('form_notes')" prop="note"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div :class="[scope.row.invoiceType==2?'red':'']">{{scope.row.note}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="发票详情" prop="note"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button  size="mini"  v-if="scope.row.invoiceDetail==1" type="text" @click="detail(scope.row)">详情</el-button>
                    <el-button  size="mini"   v-if="scope.row.invoiceDetail==0" type="text" @click="zhuaqu(scope.row)">重新获取</el-button>

                </template>
            </el-table-column>

            <el-table-column align="center" label="附件" width="68px" prop="vc_sktype"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <a v-if="scope.row.invoiceFile"
                       :download="scope.row.invoiceFile"
                       mce_href="#"
                       :href="file_root+'/'+scope.row.invoiceFile">
                        <i class="el-icon-paperclip"></i>
                    </a>
                    <el-button  size="mini" v-else  type="text" @click="zhuaqu(scope.row)">重新获取</el-button>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" prop="f_txlv1"  show-overflow-tooltip width="60px">
                <template slot-scope="scope">
                    <el-button  size="mini"  v-if="scope.row.invoiceType==2&&scope.row.relativeBlueCode==''" type="text" @click="guanlian(scope.row)">关联</el-button>
                    <el-button  size="mini"  v-if="scope.row.isUse==0&&scope.row.i_source ==2&&scope.row.canDisable == 1" type="text" @click="nullifyTun(scope.row)" style="color: red">{{$t('button_nullify')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        @size-change="sizeChange"
                        :page-sizes="[20,50,100]"
                        layout="total,sizes,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog
                    class="cldialog"
                    style="display: flex;justify-content: center;align-items: center;"
                    width="80%"
                    top="30"
                    height="300"
                    title="详情"
                    :visible.sync="detailDialog"
                    v-if="detailDialog"
                    :close-on-click-modal="false" @close="detailClose">
                <detail-page :data="detailData" @close="detailClose"></detail-page>
            </el-dialog>
            <el-dialog
                    class="cldialog"
                    style="display: flex;justify-content: center;align-items: center;"
                    width="780px"
                    top="30"
                    height="300"
                    title="关联蓝字发票"
                    :visible.sync="lanziDialog"
                    v-if="lanziDialog"
                    :close-on-click-modal="false" @close="lanziClose">
                <lanzi-fapiao :data="lanziData" @close="lanziClose"></lanzi-fapiao>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import DetailPage from "./DetailPage"
    import LanziFapiao from "./LanziFapiao"
    import {baseerp,baseApp,file_root,baseVersion} from "@/utils/baseUrl";


    export default {
        name: "index",
        components: {
            DetailPage,LanziFapiao,

        },
        data() {
            return {
                loading:true,
                tableHeight:0,
                baseerp:'',
                token:'',
                i_uid:'',
                file_root: '',
                baseApp:"",
                baseVersion:"",
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                detailData:{},
                detailDialog:false,
                detailTitle:'新增',
                lanziData:{},
                lanziDialog:false,
                gsList:[],
                i_gsid:0,
                khList:[],
                i_khid:0,
                invoiceTypeList:[{i_id:0,vc_name:'全部类型'},{i_id:2,vc_name:'红字'},{i_id:1,vc_name:'蓝字'}],
                invoiceType:0,
                invoiceStatus:0,
                invoiceStatusList:[{i_id:0,vc_name:'全部状态'},{i_id:1,vc_name:'正常'},{i_id:2,vc_name:'已冲红'},{i_id:3,vc_name:'已作废'}],
                fetachStatus:0,
                fetachStatusList:[{i_id:0,vc_name:'全部'},{i_id:1,vc_name:'附件待完善'},{i_id:2,vc_name:'详情待完善'},{i_id:3,vc_name:'红字待完善'}],
                searchkh:'',
                searchTime:[],
                invoiceCode:'',
                invoiceNum:'',
                electronicNumber:'',
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_root = file_root;
            this.getDay();
            // this.getbzlist();
            this.getKhlistWithNoRights();
            this.getCompanyList();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-150

            },
            dateChange(){
                if(this.searchTime){
                    this.startDate=this.searchTime[0];
                    this.endDate=this.searchTime[1];
                    this.currentPage=1;
                    this.withInvoiceServer();
                }

            },
            changegs(){
                if(this.i_gsid){
                    this.gsname=this.gsList.find(gs=>this.i_gsid==gs.i_id).vc_name
                }
            },
            changekh(){
                if(this.i_khid){
                    this.khname=this.khList.find(kh=>this.i_khid==kh.i_id).vc_name
                }
            },
            typeChange(){
                this.getKhlistWithNoRights()
            },
            addnew(){
                if(this.searchTime){
                    if((this.invoiceCode!==''&&this.invoiceNum!=='')||this.electronicNumber!==''){
                        this.$message.warning('时间和发票编号二选一')
                    }else{
                        this.withInvoiceServer6()

                    }
                }else{
                    if((this.invoiceCode!==''&&this.invoiceNum!=='')||this.electronicNumber!==''){
                        this.withInvoiceServer6()
                    }else{
                        this.$message.warning('时间和发票编号二选一')

                    }
                }
            },
            detail(item){
                this.detailData=item
                this.detailDialog=true;
            },
            zhuaqu(item){
                this.withInvoiceServer3(item)
            },
            guanlian(item){
                this.lanziData=item
                this.lanziDialog=true;
            },
            detailClose(type='back'){
                if(type=='save'){
                    this.currentPage=1;
                    this.withInvoiceServer()
                }
                this.detailDialog=false;

            },
            lanziClose(type='back'){
                if(type=='save'){
                    // this.currentPage=1
                    this.withInvoiceServer()
                }
                this.lanziDialog=false;

            },
            gosearch(){
                if(!this.searchTime){
                    this.$message.warning('请选择搜索的时间段');
                }else{
                    this.currentPage=1;
                    this.withInvoiceServer();
                }

            },
            clearSearchData(){
                this.i_gsid=0;
                this.i_khid=0;
                this.fetachStatus=0;
                this.invoiceType=0;
                this.invoiceCode='';
                this.invoiceNum='';
                this.electronicNumber='';
                this.invoiceStatus=0;
                this.currentPage=1;
                this.withInvoiceServer()
            },
            remoteMethodkh(val){
                this.searchkh=val;
                this.getKhlistWithNoRights();
            },
            async getKhlistWithNoRights(){
                let param={
                    i_khtype:'2,3,4,5,6,7,8',
                    currentPage:1,
                    pageSize: 50,
                    vc_search: this.searchkh,
                };
                let res=await API.getKhlistWithNoRights(param);
                if ( res.code == 1 ){
                    this.khList=res.data.list;
                    this.khList.unshift({i_id:0,vc_name:'全部开票方'});
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_type:'0,2',
                    i_mid:this.mid,
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                    this.i_gsid=this.gsList[0].i_id
                    this.gsname=this.gsList[0].vc_name
                    this.withInvoiceServer();

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async withInvoiceServer(){
                let param={
                    serviceType:1,
                    searchParam:{
                        currentPage:this.currentPage,
                        pageSize:this.pageSize,
                        endDate:this.endDate,
                        startDate:this.startDate,
                        compnayId:this.i_gsid,
                        companyName:this.gsname,
                        customerName:this.i_khid==0?'':this.khname,
                        customerId:this.i_khid,
                        fetachStatus:this.fetachStatus,
                        invoiceCode:this.invoiceCode,
                        invoiceNum:this.invoiceNum,
                        electronicNumber:this.electronicNumber,
                        invoiceStatus:this.invoiceStatus,
                        invoiceType:this.invoiceType,
                    }
                };
                let res=await API.withInvoiceServer(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.invoiceList;
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.withInvoiceServer();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.withInvoiceServer();
            },
            getDay(){
                const date=new Date();
                const y=date.getFullYear()
                const m=(date.getMonth()+1).toString().padStart(2,'0');
                const prem=date.getMonth().toString().padStart(2,'0');
                const d=date.getDate().toString().padStart(2,'0');
                this.startDate=y+'-'+m+'-'+'01';
                this.endDate=y+'-'+m+'-'+d;
                this.preMDate=y+'-'+prem+'-'+d;
                this.searchTime=[ this.startDate,this.endDate]
            },
            async withInvoiceServer3(row){
                let param={
                    serviceType:3,
                    reFetchParam:row
                };
                let res=await API.withInvoiceServer(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.currentPage=1;
                    this.withInvoiceServer();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async withInvoiceServer6(row){
                let param={
                    serviceType:6,
                    manualFetchParam:{
                        endDate:this.endDate,
                        startDate:this.startDate,
                        companyId:this.i_gsid,
                        buyerName:this.gsname,
                        invoiceNum:this.invoiceNum,
                        invoiceCode:this.invoiceCode,
                        electronicNumber:this.electronicNumber,
                    }
                };
                let res=await API.withInvoiceServer(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.currentPage=1;
                    this.withInvoiceServer();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            nullifyTun(row){
                this.$confirm('是否作废这条数据',this.$t('tips_prompt'),{
                    // this.$confirm(this.$t('companyManageMD_do_you_want_to_these_pieces_of_data',[typename,tableData.length]),this.$t('tips_prompt'),{
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type:"warning"
                }).then(()=>{
                    this.disableInvoice(row)
                }).catch(()=>{
                    this.$message.info(this.$t('tips_cancel_operation'))
                })
            },
            async disableInvoice(row){
                this.loading=true;
                let param = {
                    i_id:row.recordId,
                };
                let res = await API.disableInvoice(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.$message.success(res.message);
                    this.withInvoiceServer();
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        align-items: center;
        flex-wrap:wrap ;

    }
    .bottom8{
        margin: 8px;
    }
    .el-radio{
        margin-right: 10px;
    }
    .red{
        color: red;
    }
</style>